import * as React from 'react';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText3 } from '@cian/ui-kit/typography';
import { clsx } from 'clsx';

import * as styles from './styles.css';

export interface IReliableLabelProps {
  light?: boolean;
  onOpen?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabel({ onOpen, onClick, light }: IReliableLabelProps) {
  return (
    <div
      className={clsx(styles['container'], styles['reliable'], light && styles['reliable-light'])}
      onMouseEnter={onOpen}
      onClick={onClick}
    >
      <IconProductTrust16 color={light ? 'icon-main-default' : 'icon-inverted-default'} />
      <div className={styles['text']}>
        <UIText3 color={light ? 'text-main-default' : 'text-inverted-default'}>Надёжный корпус</UIText3>
      </div>
    </div>
  );
}
